<div class="main" #content>
  <div class="reports-container container">
    <div class="row mt-4">
      <div
        class="col font-medium d-flex align-items-center justify-content-between"
      >
        <span class="d-flex min-h-70">
          <table *ngIf="departments && departments.length">
            <tr>
              <td><b>Department</b></td>
              <td
                *ngIf="
                  selectedDepartment &&
                  selectedDepartment != '00000000-0000-0000-0000-000000000000'
                "
              >
                Room
              </td>
              <td></td>
            </tr>
            <tr>
              <td>
                <select
                  #departmentselect
                  class="clean-select"
                  [(ngModel)]="selectedDepartment"
                  (change)="getAllRooms(departmentselect.value)"
                >
                  <option [value]="emptyGuid">All</option>
                  <option
                    *ngFor="let department of departments"
                    [value]="department.id"
                  >
                    {{ department.departmentname }}
                  </option>
                </select>
              </td>
              <td *ngIf="selectedDepartment && selectedDepartment != emptyGuid">
                <select
                  #roomselect
                  class="clean-select"
                  [(ngModel)]="selectedRoom"
                  (change)="getRequests(roomselect.value)"
                >
                  <option [value]="emptyGuid">All</option>
                  <option *ngFor="let room of rooms" [value]="room.id">
                    {{ room.name }} ({{ room.roomname }})
                  </option>
                </select>
              </td>
              <td>
                <span class="d-flex">
                  <span>
                    <img
                      (click)="getRequests(selectedRoom)"
                      ngbTooltip="Refresh"
                      width="44"
                      height="44"
                      src="assets/images/refresh-icon.png"
                    />
                  </span>
                  <span>
                    <ng-container
                      *ngTemplateOutlet="exportToPdf"
                    ></ng-container>
                  </span>
                </span>
              </td>
            </tr>
          </table>
        </span>
      </div>
    </div>
  </div>
  <div class="report-container p-4">
    <div class="table-wrapper">
      <table id="tbl" class="w-100">
        <tr>
          <th class="uppercase" width="4%">Cnt</th>
          <th class="uppercase" width="14%">JSN</th>
          <th class="uppercase">Nomenclature</th>
        </tr>
      </table>
      <ng-container *ngIf="reportItems.length; else noReportData">
        <ngb-accordion
          *ngFor="let item of reportItems; let i = index"
          #acc="ngbAccordion"
          [activeIds]="activeIds"
        >
          <ngb-panel id="panel-{{ i }}">
            <ng-template ngbPanelHeader let-opened="opened">
              <button
                ngbPanelToggle
                class="w-100 btn btn-link p-0 d-flex align-items-center justify-content-between"
              >
                <table class="w-100 changes-title-bar">
                  <tr>
                    <th width="4%">[{{ item.count }}]</th>
                    <th width="14%">{{ item.jsn }}</th>
                    <th>{{ item.nomenclature }}</th>
                  </tr>
                </table>
              </button>
            </ng-template>
            <ng-template ngbPanelContent>
              <div class="changes-information">
                <table class="w-100">
                  <tr>
                    <th width="4%"></th>
                    <th width="4%">#</th>
                    <th>Department</th>
                    <th>Rooms</th>
                    <th width="10%">Change</th>
                    <th width="10%">Current</th>
                    <th width="10%">Requested</th>
                    <th>Desc. of change</th>
                    <th width="10%">Est. cost</th>
                    <th>Status</th>
                    <th width="8%">Date</th>
                  </tr>
                  <tr *ngFor="let content of item.data; let idx = index">
                    <td></td>
                    <td class="text-center">{{ idx + 1 }}</td>
                    <td>{{ content.department?.departmentname || "" }}</td>
                    <td>{{ content.rooms || "" }}</td>
                    <td>
                      {{
                        content.changedfield
                          ? content?.changedfield
                          : changeTypes[content.changetype]
                      }}
                    </td>
                    <td>{{ content.currentvalue || "" }}</td>
                    <td>{{ content.requestedvalue || "" }}</td>
                    <td>{{ content.description || "" }}</td>
                    <td>{{ content.estimatedcost || "" }}</td>
                    <td>
                      <ng-container
                        [ngTemplateOutlet]="approvalChanges"
                        [ngTemplateOutletContext]="{
                          level: content?.approvalstatus
                        }"
                      >
                      </ng-container>
                    </td>
                    <td>{{ content.createdon | date : "MM.dd.YYYY" }}</td>
                  </tr>
                </table>
              </div>
            </ng-template>
          </ngb-panel>
        </ngb-accordion>
      </ng-container>
    </div>
  </div>
</div>
<ng-template #approvalChanges let-level="level">
  <span class="lvl1" *ngIf="level == 1">Pending Approval</span>
  <span class="lvl2" *ngIf="level == 2">Pending Final Approval</span>
  <span class="lvl3" *ngIf="level == 3">Approved</span>
  <span class="lvl4" *ngIf="level == 4">Rejected</span>
</ng-template>
<ng-template #exportToPdf>
  <img
    [ngClass]="{ 'disabled-control': reportItems.length < 1 }"
    (click)="makePdf()"
    width="44"
    height="44"
    src="assets/images/pdf-icon.png"
  />
  <button
    [ngClass]="{ 'disabled-control': reportItems.length < 1 || !saveToFolder }"
    class="ml-2 d-print-none button button-action-icon border-0"
    (click)="openFolderExplorer()"
  >
    Save to folder
  </button>
</ng-template>
<ng-template #noRooms> N/A </ng-template>
<ng-template #noReportData>
  <table class="w-100">
    <tr>
      <td class="text-center">No Report Data</td>
    </tr>
  </table>
</ng-template>
